import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/new/whatsapp-1.svg'
import _imports_1 from '@/assets/images/chedid-insurance.png'
import _imports_2 from '@/assets/images/icons/visa.svg'
import _imports_3 from '@/assets/images/icons/master-card.svg'
import _imports_4 from '@/assets/images/logo/logo-white-en.svg'


const _withScopeId = n => (_pushScopeId("data-v-680d78bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mobile-footer d-md-none\" data-v-680d78bd><div class=\"container\" data-v-680d78bd><div class=\"footer-top-list_row\" data-v-680d78bd><div class=\"row gx-6\" data-v-680d78bd><div class=\"col-md-4 get-insured\" data-v-680d78bd><div class=\"footer-top-list_block h-100 d-flex flex-column justify-content-between\" data-v-680d78bd><div class=\"footer-top-list_block_item\" data-v-680d78bd><h6 data-v-680d78bd>Get Insured<span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" data-v-680d78bd></span></h6><ul data-v-680d78bd><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Car Insurance</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Health Insurance</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Home Insurance</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Bike Insurance</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Other Insurance</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Renew a policy</a></li></ul></div><div class=\"footer-top-list_block_item\" data-v-680d78bd><h6 data-v-680d78bd>Support<span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" data-v-680d78bd></span></h6><ul data-v-680d78bd><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Help center </a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd> Contact</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd> Cancellation</a></li></ul></div></div></div><div class=\"col-md-4 company\" data-v-680d78bd><div class=\"footer-top-list_block h-100 d-flex flex-column justify-content-between\" data-v-680d78bd><div class=\"footer-top-list_block_item\" data-v-680d78bd><h6 data-v-680d78bd>Company<span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" data-v-680d78bd></span></h6><ul data-v-680d78bd><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>About </a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Insurance Partners</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>HR Solutions</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Blog</a></li></ul></div><div class=\"footer-top-list_block_item\" data-v-680d78bd><h6 data-v-680d78bd>Calculators<span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" data-v-680d78bd></span></h6><ul data-v-680d78bd><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Car Loan </a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd> Mortgage</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd> Insurance Calc</a></li></ul></div></div></div><div class=\"col-md-4 quick-links-col\" data-v-680d78bd><div class=\"footer-top-list_block h-100 d-flex flex-column justify-content-between quick-links\" data-v-680d78bd><div class=\"footer-top-list_block_item\" data-v-680d78bd><h6 data-v-680d78bd>Quick links<span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" style=\"display:none;\" data-v-680d78bd></span><span class=\"icon-dropdown-down\" data-v-680d78bd></span></h6><ul data-v-680d78bd><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Privacy Page</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Terms &amp; Conditions</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>Al Manarah Insurance</a></li><li data-v-680d78bd><a href=\"#\" data-v-680d78bd>E- Darat </a></li></ul></div></div></div></div></div></div></div>", 1)
const _hoisted_2 = {
  id: "bai-footer",
  class: "footer text-white"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "footer-top" }
const _hoisted_5 = { class: "footer-top_row" }
const _hoisted_6 = { class: "row justify-content-between" }
const _hoisted_7 = { class: "col-md-6 col-lg-4 footer-col-first" }
const _hoisted_8 = { class: "footer-top_row_item" }
const _hoisted_9 = { class: "need-assitance" }
const _hoisted_10 = { class: "need-assitance_title text-uppercase" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "need-assitance_whatsapp d-flex flex-wrap align-items-center" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-fluid"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  class: "content",
  style: {"direction":"ltr"}
}
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "d-block" }
const _hoisted_20 = { class: "custom-button" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "contact-list contact-list-wrapper" }
const _hoisted_23 = { class: "contact-list_item" }
const _hoisted_24 = { class: "contact-list_item_title text-uppercase" }
const _hoisted_25 = { class: "contact-list_item_content" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "contact-list_item" }
const _hoisted_28 = { class: "contact-list_item_title text-uppercase" }
const _hoisted_29 = { class: "contact-list_item_content" }
const _hoisted_30 = {
  href: "https://maps.app.goo.gl/B5dHEAAcTpVU6RHA9",
  target: "_blank"
}
const _hoisted_31 = { class: "corporate-block" }
const _hoisted_32 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "corporate-logos" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Chedid Insurance Brokers"
  })
], -1))
const _hoisted_36 = { class: "col-lg-7 footer-list d-flex flex-column justify-content-between footer-right" }
const _hoisted_37 = { class: "footer-top-list_row" }
const _hoisted_38 = { class: "row gx-6" }
const _hoisted_39 = { class: "col-md-4 get-insured" }
const _hoisted_40 = { class: "footer-top-list_block h-100 d-flex flex-column justify-content-between" }
const _hoisted_41 = { class: "footer-top-list_block_item" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = ["href"]
const _hoisted_46 = ["href"]
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "footer-top-list_block_item" }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["href"]
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "col-md-4 company" }
const _hoisted_53 = { class: "footer-top-list_block h-100 d-flex flex-column justify-content-between" }
const _hoisted_54 = { class: "footer-top-list_block_item" }
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href"]
const _hoisted_57 = ["href"]
const _hoisted_58 = ["href"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-top-list_block_item" }, null, -1))
const _hoisted_60 = { class: "col-md-4 quick-links-col" }
const _hoisted_61 = { class: "footer-top-list_block h-100 d-flex flex-column justify-content-between quick-links" }
const _hoisted_62 = { class: "footer-top-list_block_item" }
const _hoisted_63 = ["href"]
const _hoisted_64 = ["href"]
const _hoisted_65 = ["href"]
const _hoisted_66 = ["href"]
const _hoisted_67 = { class: "social-icons footer-top-list_block_item d-flex flex-wrap" }
const _hoisted_68 = { class: "social-icons-list" }
const _hoisted_69 = ["href"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-linkedin" }, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["href"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-fb" }, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = ["href"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-instagram" }, null, -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = ["href"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-tiktok" }, null, -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = {
  key: 0,
  class: "nav d-flex justify-content-end align-items-center"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Visa",
    class: "img-fluid"
  })
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "img-fluid",
    alt: "Master Card"
  })
], -1))
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]
const _hoisted_85 = { class: "footer-bottom" }
const _hoisted_86 = { class: "row align-items-center row-cols-md-2 row-cols-1" }
const _hoisted_87 = { class: "col-lg-4 col-md-12" }
const _hoisted_88 = {
  key: 0,
  src: _imports_4,
  class: "img-fluid footer-bottom-logo"
}
const _hoisted_89 = {
  key: 1,
  src: _imports_4,
  class: "img-fluid footer-bottom-logo"
}
const _hoisted_90 = { class: "col-lg-4 col-md-12" }
const _hoisted_91 = { class: "copyright text-center" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://chedid-capital.com/",
  target: "_blank"
}, "Chedid Capital", -1))
const _hoisted_93 = ["href"]
const _hoisted_94 = { class: "d-block" }
const _hoisted_95 = { class: "col-lg-4 col-md-12" }
const _hoisted_96 = { class: "copyright text-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t("need_assistance")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("a", {
                          href: _ctx.companyInfo.whatsapp_url,
                          target: "_blank"
                        }, _hoisted_16, 8, _hoisted_14)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("a", {
                          href: _ctx.companyInfo.toll_free_number_tel
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t("call_us")) + " ", 1),
                          _createElementVNode("span", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.companyInfo.toll_free_number) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('or')), 1)
                          ])
                        ], 8, _hoisted_18)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("a", {
                        href: `${_ctx.websiteUrl}/${_ctx.language}/help-center`,
                        class: "btn"
                      }, _toDisplayString(_ctx.$t("support_center")), 9, _hoisted_21)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("mail")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", null, [
                          _createElementVNode("a", {
                            href: `mailto:${_ctx.companyInfo.email}`
                          }, _toDisplayString(_ctx.companyInfo.email), 9, _hoisted_26)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("head_office")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.companyInfo.address), 1),
                          _createElementVNode("a", _hoisted_30, [
                            _createTextVNode(" - "),
                            _createElementVNode("u", null, _toDisplayString(_ctx.$t("google_map")), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("h4", null, [
                          _createElementVNode("a", {
                            href: `${_ctx.websiteUrl}/${_ctx.language}/corporate-solutions`
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("corporate")) + " ", 1),
                            _hoisted_34,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("solution")), 1)
                          ], 8, _hoisted_33)
                        ]),
                        _hoisted_35
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("get_insured")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/car-insurance`
                              }, _toDisplayString(_ctx.$t("car_insurance")), 9, _hoisted_42)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/bike-insurance-lebanon`
                              }, _toDisplayString(_ctx.$t("bike_insurance")), 9, _hoisted_43)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/travel-insurance`
                              }, _toDisplayString(_ctx.$t("travel_insurance")), 9, _hoisted_44)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/expat-health-insurance`
                              }, _toDisplayString(_ctx.$t("expat_insurance")), 9, _hoisted_45)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/health-insurance`
                              }, _toDisplayString(_ctx.$t("health_insurance")), 9, _hoisted_46)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/home-insurance`
                              }, _toDisplayString(_ctx.$t("home_insurance")), 9, _hoisted_47)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("support")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/help-center`
                              }, _toDisplayString(_ctx.$t("help_center")), 9, _hoisted_49)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/contact-us`
                              }, _toDisplayString(_ctx.$t("contact")), 9, _hoisted_50)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/faqs`
                              }, _toDisplayString(_ctx.$t("faqs")), 9, _hoisted_51)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("company")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/about-us`
                              }, _toDisplayString(_ctx.$t("about")), 9, _hoisted_55)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/insurance-partners`
                              }, _toDisplayString(_ctx.$t("insurance_partners")), 9, _hoisted_56)
                            ]),
                            _createElementVNode("li", {
                              class: _normalizeClass(`${_ctx.language == 'ar' ? 'd-none' : ''}`)
                            }, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/blog/${_ctx.language == 'ar' ? _ctx.language : ''}`
                              }, _toDisplayString(_ctx.$t("blog")), 9, _hoisted_57)
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass(`${_ctx.language == 'ar' ? 'd-none' : ''}`)
                            }, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/blog/news`
                              }, _toDisplayString(_ctx.$t("news")), 9, _hoisted_58)
                            ], 2)
                          ])
                        ]),
                        _hoisted_59
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("quick_links")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/privacy-policy`
                              }, _toDisplayString(_ctx.$t("privacy_page")), 9, _hoisted_63)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/terms-and-conditions`
                              }, _toDisplayString(_ctx.$t("tac")), 9, _hoisted_64)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/corporate-solutions`
                              }, _toDisplayString(_ctx.$t("corporate_solution")), 9, _hoisted_65)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.websiteUrl}/${_ctx.language}/complaints-procedures`
                              }, _toDisplayString(_ctx.$t("complaints_procedures")), 9, _hoisted_66)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("ul", _hoisted_68, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.linkedin}`,
                                target: "_blank"
                              }, _hoisted_71, 8, _hoisted_69)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.facebook}`,
                                target: "_blank"
                              }, _hoisted_74, 8, _hoisted_72)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.instagram}`,
                                target: "_blank"
                              }, _hoisted_77, 8, _hoisted_75)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: `${_ctx.tiktok}`,
                                target: "_blank"
                              }, _hoisted_80, 8, _hoisted_78)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                (!_ctx.is_omt_flow)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_81, _hoisted_84))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              (_ctx.language ===  'ar')
                ? (_openBlock(), _createElementBlock("img", _hoisted_88))
                : (_openBlock(), _createElementBlock("img", _hoisted_89))
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("company_of")) + " ", 1),
                  _hoisted_92
                ]),
                _createElementVNode("a", {
                  style: {"text-decoration":"underline !important"},
                  href: _ctx.companyInfo.landline_number_tel
                }, [
                  _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.companyInfo.landline_number), 1)
                ], 8, _hoisted_93)
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t('copyrights_footer').replace('DATE_FOOTER', new Date().getFullYear())) + " ", 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}